import React from "react";
import FormField from "../../../../../dynamicFormBuilder/FormField";
import CommonReport from "../../../../../reports/components/CommonReport";
import { CalculateLayout } from "../Layout";
import { LAYOUT_ID, LAYOUT_NAME, REPORT_NAME, REPORT_FULL_NAME } from "../constants";
import "../calculateDeferredRevenue.css";

/**
 * The parameters tab, laid out in the same vertical order as the Delphi form (uWMD0088.dfm):
 *
 *   1. the Record Range / ad-hoc filter builder (grpTopRight / wbDeferredRevenue)
 *   2. the three parameter group boxes          (grpBottomLeft / Middle / Right)
 *
 * The context-sensitive help band is NOT here: in Delphi edtHelpMemo is a sibling of the page control
 * with Align = alTop, so it spans all five tabs. It lives in the page component instead.
 *
 * Presentational — all state lives in the page component. formRefs is threaded through so the page
 * can drive the Acct Source enable/disable rule and focus a field on validation failure.
 */
const CalculateTab = (props) => {
    const {
        currentUser,
        dynamicFormSetting,
        formFields,
        setFormFields,
        formRefs,
        handleFieldChange,
        handleFormLoad,
        onReportStateChange,
        reportRef,
    } = props;

    return (
        <div className="cdr-calculate-tab">
            <div className="op-filter">
                <CommonReport
                    name={REPORT_NAME}
                    fullName={REPORT_FULL_NAME}
                    onReportStateChange={onReportStateChange}
                    innerRef={reportRef}
                />
            </div>

            <div className="op-parameters">
                <FormField
                    currrentUser={currentUser}
                    layoutId={LAYOUT_ID}
                    layoutName={LAYOUT_NAME}
                    defaultFormSchema={CalculateLayout}
                    formFields={formFields}
                    setformFields={setFormFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={dynamicFormSetting}
                    formRefs={formRefs}
                    onFormLoad={handleFormLoad}
                />
            </div>
        </div>
    );
};

export default CalculateTab;
